// «UI nuova» switch (docs/ui-nuova/MIGRATION-PLAN.md §1.1; M18 ec-enable, recipe
// docs/ui-nuova/briefs/M9-query-only-apps.md). The public shop opts in QUERY-ONLY:
// enable({ queryOnly: true }) shows no switch anywhere (shoppers never see one,
// not even on the preview tenants); the new UI applies only on a device opened
// with `?ui=new` (`?ui=old` locks it again) or, in a non-production build, with a
// stored choice. enable() also re-stamps html[data-ui] (the inline script in
// index.html already did it before boot, so no flash) and tags Sentry. The
// tenant of the unlock is the public organization slug, pushed by
// routes/application.js (ui.setTenant): shoppers are anonymous. service:session
// is never looked up here (an eager lookup at boot instantiates the real session
// before the test mocks and its HTTPS redirect kills the runner).
export function initialize(appInstance) {
  appInstance.lookup('service:ui')?.enable({ queryOnly: true });
}

export default {
  initialize,
};
